import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { IconChevronRight } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { ImageSlider } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ImageSlider/index.js';
import { ReviewAttributes } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ReviewAttributes.js';
import { ScoreBar } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ScoreBar.js';
import { UserName } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/UserName.js';
import { ActionLink, Flex, HeadlineSmall, ParagraphMedium } from '../../../../../primitives/index.js';
export const ReviewItem = ({
  review,
  highlighted = false,
  onClickDetailButton,
  onClickImage
}) => {
  const {
    t
  } = useTranslation();
  const mdDown = useBreakpointDown('md');
  const highlightingProps = highlighted ? {
    padding: mdDown ? '12px' : '16px',
    backgroundColor: 'backgroundTertiary',
    borderRadius: 5
  } : null;
  return _jsxs(Flex, {
    ...highlightingProps,
    spacing: "pages/small",
    children: [_jsxs(Flex, {
      spacing: review.headline ? 'pages/small' : '8px',
      children: [_jsxs(Flex, {
        direction: "row",
        justifyContent: "space-between",
        children: [_jsx(UserName, {
          firstName: review.firstName,
          lastName: review.lastName
        }), _jsx(ScoreBar, {
          rating: review.rating,
          contained: true
        })]
      }), _jsxs(Flex, {
        spacing: "4px",
        children: [review.headline && _jsx(HeadlineSmall, {
          children: review.headline
        }), _jsx(ReviewAttributes, {
          review: review
        })]
      })]
    }), review.conclusion && _jsx(ParagraphMedium, {
      children: review.conclusion
    }), Array.isArray(review.photos) && review.photos.length > 0 && _jsx(ImageSlider, {
      images: review.photos.map(photo => ({
        src: photo,
        alt: ''
      })),
      onClickImage: onClickImage
    }), _jsx("div", {
      children: _jsxs(ActionLink, {
        size: "medium",
        bold: true,
        onClick: onClickDetailButton,
        children: [t('hotelDetailsOverlay:amadeusRatingSection.reviewItem.showReview'), _jsx(IconChevronRight, {})]
      })
    })]
  });
};